import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['card', 'count']

  connect() {
    this.filter()
  }

  filter() {
    const availability = this.element
      .querySelector(
        '[data-filter="availability"]'
      )?.value || 'all'

    const city = this.element
      .querySelector(
        '[data-filter="city"]'
      )?.value || 'all'

    const sqft = this.element
      .querySelector(
        '[data-filter="sqft"]'
      )?.value || 'all'

    let visible = 0

    this.cardTargets.forEach((card) => {
      const show =
        this.#matchAvailability(card, availability) &&
        this.#matchCity(card, city) &&
        this.#matchSqft(card, sqft)

      card.classList.toggle('hidden', !show)
      if (show) visible++
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent =
        `${visible} ${
          visible === 1
            ? 'property'
            : 'properties'
        }`
    }
  }

  reset() {
    this.element.querySelectorAll('select[data-filter]')
      .forEach((s) => (s.value = 'all'))

    this.filter()
  }

  #matchAvailability(card, value) {
    if (value === 'all') return true

    return card.dataset.available === value
  }

  #matchCity(card, value) {
    if (value === 'all') return true

    return card.dataset.city === value
  }

  #matchSqft(card, value) {
    if (value === 'all') return true

    const sqft = parseInt(card.dataset.sqft, 10)

    switch (value) {
      case '0-1000':
        return sqft <= 1000
      case '1000-2500':
        return sqft > 1000 && sqft <= 2500
      case '2500+':
        return sqft > 2500
      default:
        return true
    }
  }
}
